{
  "cash": "Efectivo",
  "noCashAssetClassFound": "No se encontró ninguna clase de activo de efectivo en las ramas configuradas. Por favor, agregue primero una rama de clase de activo de efectivo.",
  "cashFetchError": "No se pudo obtener el producto financiero de efectivo. Por favor, inténtelo de nuevo.",
  "other": "Otro",
  "editModel": "Editar modelo",
  "details": "Detalles",
  "disclaimer": "Descargo de responsabilidad",
  "auditLog": "Registro de auditoría",
  "portfolioAllocation": "Asignación sobre la cartera",
  "investmentPolicyStatement": "Declaración de política de inversión",
  "selectModel": "Seleccione o cree un modelo de la lista",
  "primaryAssetClasses": "Clases de activos principales",
  "secondaryAssetClasses": "Clases de activos secundarios",
  "securities": "Valores",
  "name": "Nombre",
  "percentage": "Porcentaje",
  "taxRank": "Clasificación fiscal",
  "secondaryAssetClass": "Clase de activo",
  "minimum": "Mínimo",
  "maximum": "Máximo",
  "actual": "Actual",
  "unknown": "Desconocido",
  "transition": {
    "draft": "Mover a Borradores",
    "activate": "Mover a activo",
    "archive": "Mover a archivado"
  },
  "transitionTheme": {
    "successfulTransition": "Tema cambiado correctamente",
    "unableToArchiveError": "No se puede archivar. Este tema está asignado actualmente a {{numActivePortfolios}} carteras activas.",
    "archiveConfirmationModal": {
      "title": "¿Está seguro de que desea archivar?",
      "confirm": "Confirmar",
      "cancel": "Cancelar"
    }
  },
  "themeModal": {
    "updateTitle": "Actualizar tema",
    "title": "Crear nuevo tema",
    "key": "Clave",
    "name": "Nombre",
    "description": "Descripción",
    "shortDescription": "Descripción corta",
    "organization": "Organización",
    "defaultRecommendation": "Recomendación predeterminada",
    "iconKey": "Ícono",
    "successMessages": {
      "create": "El tema se ha creado correctamente.",
      "update": "El tema se ha actualizado correctamente."
    },
    "errorMessages": {
      "create": "No se puede crear el tema, inténtalo de nuevo.",
      "update": "No se puede actualizar el tema, inténtelo de nuevo."
    }
  },
  "modelModal": {
    "title": "Crear modelo nuevo",
    "name": "Nombre",
    "organization": "Organización"
  },
  "core": "BASE",
  "edit": {
    "name": "Nombre",
    "porfolioDescription": "Descripción",
    "investmentObjective": "Objetivo de la inversión",
    "theme": "Tema",
    "suggestable": "Sugestionable",
    "forecastedRateOfReturn": "Tasa de rendimiento prevista",
    "forecastedStandardDeviation": "Desviación estándar prevista",
    "lowThresholdScore": "Puntuación mínima requerida",
    "suggestedMinScore": "Puntuación mínima",
    "suggestedMaxScore": "Puntuación máxima",
    "riskReturnLevel": "Nivel de riesgo/rendimiento",
    "save": "Guardar",
    "post": "Publicar",
    "triggerReSign": {
      "button": "Activar la renovación de la firma del IPS",
      "triggerButton": "Desencadenar",
      "confirmationTitle": "¿Está seguro de que quiere que los clientes vuelvan a firmar el acuerdo?",
      "confirmationMessage": "Si procede, todos los clientes que tengan esta cartera deberán volver a firmar su contrato antes de que se rebalanceen sus cuentas.",
      "updateReason": "Motivo de la actualización",
      "toastMessage": "Se ha activado la renovación del IPS."
    },
    "disclaimerMarkdownLabel": "Aviso legal sobre la cartera",
    "clear": "Borrar",
    "liquidityInfo": "Liquidez",
    "url": "Enlace a los detalles del fondo"
  },
  "editAllocation": {
    "updatedToastMessage": "Se han actualizado las asignaciones de la cartera modelo."
  },
  "editAccount": {
    "title": "Editar número de cuenta",
    "accountNumber": "Número de cuenta",
    "update": "Actualice el número de cuenta"
  },
  "editTlh": {
    "title": "Habilitar la compensación de pérdidas fiscales",
    "true": "Sí",
    "false": "No"
  },
  "newNote": {
    "title": "Escriba una nota",
    "characters": "caracteres",
    "clear": "Sí, borrar",
    "cancelClear": "No, no borrar",
    "delete": "Sí, eliminar",
    "cancelDelete": "No, no borrar",
    "deleteTitle": "Eliminar nota",
    "deleteSubText": "¿Está seguro de que desea eliminar esta nota?",
    "clearTitle": "Borrar Nota",
    "clearSubText": "¿Está seguro de que desea borrar esta nota?",
    "deleteWarning": "No tiene permiso para borrar esta nota.",
    "updateWarning": "No tiene permiso para actualizar esta nota.",
    "noteUserPostFix": "  agregado:",
    "thereAreNoNotes": "No hay notas que mostrar"
  },
  "update": "Actualizar"
}
